module.exports = __webpack_public_path__ + "img/logo-teal-flat.0bc41e4c.png";